import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store/types/RootState';

type NotesSlice = RootState['notes'];

const selectNotesSlice = (state: RootState) => state?.notes;

export const selectNoteList = createSelector(selectNotesSlice, (state: NotesSlice) => state?.data?.listings || []);

export const selectNoteListPagination = createSelector(
  selectNotesSlice,
  (state: NotesSlice) => state?.data?.pagination,
);

export const selectNoteEntityOptions = createSelector(selectNotesSlice, (state: NotesSlice) => state?.noteEntities);

export const selectNoteReminders = createSelector(selectNotesSlice, (state: NotesSlice) => state.reminders.listings);

export const selectNotesAreLoading = createSelector(selectNotesSlice, (state: NotesSlice) => state?.statuses.isLoading);

export const selectNoteUpdateInProgress = (noteId: number) => (state: RootState) =>
  !!state.notes.statuses.noteUpdateInProgress[noteId];
